import {
  defineRxSystem,
  defineSystem,
  Entity,
  getComponentValueStrict,
  Has,
  removeComponent,
  runQuery,
  setComponent,
} from "@latticexyz/recs";
import { HeadlessLayer } from "../../types";

export function createCooldownSystem(layer: HeadlessLayer) {
  const {
    world,
    components: { OnCooldown },
    parentLayers: {
      network: {
        network: {
          components: { LastAction },
          clock
        },
        api: { getCurrentMatchConfig },
      },
    },
    actions,
  } = layer;

  const OptimisticLastAction = actions.withOptimisticUpdates(LastAction);

  const setCooldown = (atTime: number, entity: Entity) => {
    const gameConfig = getCurrentMatchConfig();
    if (!gameConfig) return;
    const cooldownTime = gameConfig.actionCooldownLength;

    const lastAction = getComponentValueStrict(OptimisticLastAction, entity);
    const lastActionTime = lastAction.value;

    if (lastActionTime + cooldownTime > atTime) {
      setComponent(OnCooldown, entity, { value: true });
    } else {
      removeComponent(OnCooldown, entity);
    }
  };

  defineRxSystem(world, clock.time$, (time) => {
    const currentTime = time / 1000;
    for (const entity of runQuery([Has(LastAction)])) {
      setCooldown(currentTime, entity);
    }
  });

  defineSystem(world, [Has(OptimisticLastAction)], ({ entity }) => {
    setCooldown(clock.currentTime / 1000, entity);
  });
}
